import { useState } from 'react';
import PhoneButton from './PhoneButton';
import Hyperlinks from './Hyperlinks';
import QuickNavigation from './QuickNavigation';

const navigationSections = [
  { id: 'top', label: 'Top 5' },
  { id: 'security', label: 'Sikkerhed' },
  { id: 'tax', label: 'Skat' },
  { id: 'verification', label: 'Verifikation' },
  { id: 'payment', label: 'Betalingsmetoder' },
  { id: 'factors', label: 'Faktorer' },
  { id: 'tips', label: 'Råd' },
  { id: 'Konklusion', label: 'Konklusion' }
];

export default function FloatingButtons() {
  const [activePopup, setActivePopup] = useState(null);
  const [activeSection, setActiveSection] = useState('top');

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveSection(id);
    }
  };

  return (
    <>
      <PhoneButton
        isOpen={activePopup === 'phone'}
        onToggle={() => setActivePopup(activePopup === 'phone' ? null : 'phone')}
      />

      <Hyperlinks
        isOpen={activePopup === 'hyperlinks'}
        onToggle={() => setActivePopup(activePopup === 'hyperlinks' ? null : 'hyperlinks')}
      />

      <QuickNavigation
        isOpen={activePopup === 'quickNav'}
        onToggle={() => setActivePopup(activePopup === 'quickNav' ? null : 'quickNav')}
        navigationSections={navigationSections}
        scrollToSection={scrollToSection}
        activeSection={activeSection}
      />
    </>
  );
}
